/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 7:45 AM
 *
 */

export enum ROLE {
  SCHOOL_ADMIN = 'school_admin',
  SCHOOL_STUDENT = 'school_student',
  SCHOOL_TEACHER = 'school_teacher',
  SCHOOL_OPERATOR = 'school_operator',
}
